export class TooltipDefinitions extends HTMLElement {

    definitions = {};
    constructor() {
        super();
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.loadDefinitions();
        this.initEventListeners();
    }

    loadDefinitions() {
        // definitions are contained in templates within this element
        const definitionTemplates = this.querySelectorAll('template');
        definitionTemplates.forEach(template => {
            const termId = template.dataset.term_id;
            const templateContent = template.content;
            const defTooltip = templateContent.querySelector('definition-tooltip');
            if (defTooltip) {
                this.definitions[termId] = defTooltip;
            }
        });
    }

    initEventListeners() {
        // listen for requests for definitions
        const dfns = document.querySelectorAll('dfn[title]');
        dfns.forEach(dfn => {
            dfn.addEventListener('mouseover', this.handleDefinitionRequest.bind(this));
        });
    }

    handleDefinitionRequest(event) {
        const termId = event.target.getAttribute('title');
        // check if definition is already shown
        if (event.target.querySelector('definition-tooltip')) {
            return;
        }

        const definition = this.getDefinition(termId);
        if (definition) {
            event.target.appendChild(definition);
            setTimeout(() => {
                const dialog = definition.querySelector('dialog');
                dialog.style.opacity = '1';
            }, 100); // slight delay to allow for transition
        }
    }

    getDefinition(termId) {
        if (termId in this.definitions) {
            const clone = this.definitions[termId].cloneNode(true);
            return clone;
        }
        return null;
    } 
}

customElements.define('tooltip-templates', TooltipDefinitions); 
